import { motion, useReducedMotion } from "framer-motion";
import { EASE, Reveal } from "@/components/Reveal";
import { SmsSignup } from "@/components/SmsSignup";

export const JesterTeaser = () => {
  const reduce = useReducedMotion();
  return (
    <section id="jester" data-testid="jester-teaser" className="border-t">
      <div className="mx-auto grid max-w-[1600px] gap-10 px-4 py-24 md:grid-cols-12 md:gap-10 md:px-8 md:py-36">
        <motion.div
          className="relative md:col-span-7"
          initial={reduce ? false : { opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="relative flex aspect-square items-center justify-center overflow-hidden bg-[#EEEBE5]">
            <motion.img
              src="/img/jester-hoodie.webp"
              alt="Sviin 'Jester' zip hoodie in washed grey with a juggling jester graphic"
              loading="lazy"
              className="h-full w-full object-contain p-[9%] mix-blend-multiply"
              animate={reduce ? undefined : { y: [0, -10, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            />
            <span className="label absolute left-4 top-4 bg-[#111111] px-2.5 py-1.5 text-[10px] text-[#F4F2EE]">Coming soon</span>
          </div>
        </motion.div>
        <div className="flex flex-col justify-center md:col-span-5">
          <Reveal>
            <p className="label flex items-center gap-2 text-[#E2541B]">
              <span className="inline-block h-1.5 w-1.5 animate-pulse bg-[#E2541B]" /> Dropping soon
            </p>
            <h2 data-testid="jester-title" className="mt-5 font-['Geist',sans-serif] text-7xl font-light leading-[0.9] tracking-[-0.06em] sm:text-8xl lg:text-[9rem]">
              Jester
            </h2>
            <p className="label mt-5 text-[#111111]/60">Zip hoodie — Drop 02</p>
          </Reveal>
          <Reveal delay={0.1} data-testid="jester-archetype">
            <p className="label mt-10 text-[#111111]/60">( The archetype )</p>
            <h3 className="mt-4 font-['Geist',sans-serif] text-2xl font-light leading-[1.15] tracking-[-0.03em] md:text-3xl">
              The jester laughs in the dark<span className="text-[#111111]/45"> — and sees what everyone else misses.</span>
            </h3>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-[#111111]/75">
              Behind every smile is something unspoken. The jester wears the mask not to hide, but to move freely —
              turning weight into wit, and pain into something people can laugh with. Never the fool in the room,
              always the sharpest mind in it.
            </p>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-[#111111]/75">
              Jester is for the ones who carry more than they show, and still choose to smile.
            </p>
            <ul className="mt-8 grid max-w-lg grid-cols-2 border-l border-t">
              {["Laughter in the dark", "The mask & the smile", "Freedom of mind", "Quiet intelligence"].map((t, i) => (
                <li key={t} className="border-b border-r p-3 md:p-4">
                  <span className="label text-[10px] text-[#E2541B]">{String(i + 1).padStart(2, "0")}</span>
                  <p className="mt-1.5 text-sm leading-snug">{t}</p>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-10 max-w-md text-sm leading-relaxed text-[#111111]/75">
              Be the first to know when it lands — we'll text you the moment the Jester goes live.
            </p>
          </Reveal>
          <Reveal delay={0.22} className="mt-4">
            <SmsSignup source="jester" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
